export const formatUSPhone = (raw) => {
  const d = String(raw || "").replace(/\D/g, "").replace(/^1(?=\d{10})/, "").slice(0, 10);
  if (d.length === 0) return "";
  if (d.length < 4) return `(${d}`;
  if (d.length < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
};

// Display formatter: (###) ###-#### for 10-digit US numbers, keeps ext / other text otherwise
export const formatPhone = (raw) => {
  if (!raw) return "";
  const s = String(raw).trim();
  const m = s.match(/^\s*(?:\+?1[\s.-]*)?\(?(\d{3})\)?[\s.-]*(\d{3})[\s.-]*(\d{4})\s*(.*)$/);
  if (!m) return s;
  const ext = m[4] ? ` ${m[4].trim()}` : "";
  return `(${m[1]}) ${m[2]}-${m[3]}${ext}`;
};
